import React, { PropTypes } from 'react';
import PlayersEditForm from '../PlayersEditForm';
import LoadingSpinner from '../../LoadingSpinner';

class PlayerNew extends React.Component {
  static propTypes = {
    fetch: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired
  };

  componentDidMount() {
    this.props.fetch();
  }

  render() {
    let { loading, rest } = this.props;

    return (
      <LoadingSpinner show={loading}>
        <PlayersEditForm label="Create Player" {...rest}/>
      </LoadingSpinner>
    );
  }
}

export default PlayerNew;



// WEBPACK FOOTER //
// ./src/components/Players/PlayersNew/PlayersNew.js